import { render, staticRenderFns } from "./a-student-questionnaire-option.vue?vue&type=template&id=62390d74&scoped=true&"
import script from "./a-student-questionnaire-option.vue?vue&type=script&lang=js&"
export * from "./a-student-questionnaire-option.vue?vue&type=script&lang=js&"
import style0 from "./a-student-questionnaire-option.vue?vue&type=style&index=0&id=62390d74&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62390d74",
  null
  
)

export default component.exports